import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { BiSad } from "react-icons/bi";
import Navbar from "./Navbar";
import { useLocation } from "react-router-dom";

const LeaveAlertsCards = () => {
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchLeaveAlerts = async () => {
    
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;
    try {
      const response = await axios.post("https://www.careplus.gopillz.com/leave-alerts",
      JSON.stringify({ "patient_id": patient_id }),
      {
        headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
      });
      setLeaveData(response.data);
    } catch (err) {
      console.error("Failed to fetch leave data", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveAlerts();
  }, []);

  const getStatusBadge = (status, label) => (
    <div className="flex items-center gap-2 text-sm">
      {status ? (
        <FaCheckCircle className="text-green-600" />
      ) : (
        <FaTimesCircle className="text-red-500" />
      )}
      <span className={status ? "text-green-700" : "text-red-600"}>
        {label}: {status ? "Approved" : "Pending"}
      </span>
    </div>
  );

  if (loading) {
    return <div className="text-center py-20 text-lg text-gray-600">Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-teal-200">
      {/* Fixed Navbar at the top */}
      <div className="fixed top-0 left-0 right-0 z-50 shadow-md bg-white">
        <Navbar />
      </div>

      {/* Main content with padding to avoid overlap */}
      <div className="max-w-7xl mx-auto px-4 pt-24 pb-10">
        <h2 className="text-3xl font-bold text-emerald-800 mb-8 text-center">
        Leave Details for Your Child
        </h2>

        {leaveData.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 text-gray-500">
            <BiSad className="text-6xl text-gray-400 mb-4" />
            <p className="text-lg font-medium">No leave data available</p>
          </div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {leaveData.map((item, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-2xl shadow-md p-5 hover:shadow-lg transition"
              >
                <div className="mb-3">
                  <h3 className="text-xl font-semibold text-gray-800">
                    {item.patient_name || "Unnamed"} ({item.roll_number || "N/A"})
                  </h3>
                  <p className="text-sm text-gray-500 mt-1">
                    Leave Type: <span className="font-medium">{item.leave_type || "—"}</span>
                  </p>
                  <p className="text-sm text-gray-500">
                    Duration: {item.from_date} → {item.to_date}
                  </p>
                  <p className="text-sm text-gray-500">
                    Reason: <span className="italic">{item.reason || "—"}</span>
                  </p>
                </div>
                <div className="mt-4 border-t pt-3 space-y-1">
                  {getStatusBadge(item.leave_approval_status_by_doctor, "Doctor")}
                  {getStatusBadge(item.leave_approval_status_by_parent, "Parent")}
                  {getStatusBadge(item.leave_approval_status_by_warden, "Warden")}
                  {getStatusBadge(item.leave_approval_status_by_medical_officer, "Medical Officer")}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaveAlertsCards;
